import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PostState from "./createContext/Post/PostState";
import IsAuthStates from "./createContext/is-Auth/IsAuthStates";

import Register from "./components/Auth/Register/Register";
import Login from "./components/Auth/Login/Login";
import About from "./components/Auth/Register/About/About";
import Passion from "./components/Auth/Register/Passion/Passion";
import UploadPicture from "./components/Auth/Register/UploadPicture/UploadPicture";
import Dashboard from "./Dashboard";
import RegisterStates from "./createContext/Register/RegisterStates";
import ReelState from "./createContext/Reels/ReelState";
import MatchState from "./createContext/Match/MatchState";
import SearchState from "./createContext/Search/SearchState";
import WaitingScreen from "./components/Auth/Register/WaitingScreen/WaitingScreen";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute
import ProfileState from "./createContext/Profile/ProfileState";
import NotificationState from "./createContext/Notification/NotificationState";
import LandingPage from "./LandingPage";
import EnterEmail from "./components/Auth/ForgotPassword/EnterEmail";
import EnterPaswword from "./components/Auth/ForgotPassword/EnterPassword";
import Footer from "./components/Footer";
import Header from "./components/Header";
import SinglePostPage from "./components/Home/SinglePost/SinglePostPage";
import { useEffect } from "react";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs";



const useTokenManagement = () => {
   // Empty dependency array means this runs once on component mount
   useEffect(() => {
    const handleWindowClose = () => {
      const rememberMe = localStorage.getItem('RemberMe') || true;
      const doClear = sessionStorage.getItem('clearToken') || true;
      
      // Check if rememberMe is explicitly set to false
      if (rememberMe === 'false' && doClear === true) {
        // Remove authentication token from localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('RemberMe');

      }
    };

    // Add event listener for window close/beforeunload
    window.addEventListener('beforeunload', handleWindowClose);

    // Cleanup event listener
    return () => {
      window.removeEventListener('beforeunload', handleWindowClose);
    };
  }, []);
};

const PostLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="bg-[#1D1534]">
        <Header logoTheme={"dark"}/>
      </div>
      <main className="flex-grow">
        <SinglePostPage />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useTokenManagement();
  return (
    <Router>
      <RegisterStates>
        <IsAuthStates>
          <PostState>
            <ReelState>
              <SearchState>
                <MatchState>
                  <NotificationState>
                    <ProfileState>
                      <Routes>
                        {/* Public Routes (accessible without token) */}
                        <Route path="/register" element={<Register />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/" element={<LandingPage />} />
                        <Route
                          path="/forgot-password"
                          element={<EnterEmail />}
                        />
                        <Route
                          path="/reEnter-Password/:token"
                          element={<EnterPaswword />}
                        />

                        {/* Protected Routes (accessible only with token) */}
                        <Route
                          path="/register/about"
                          element={
                            <ProtectedRoute>
                              <About />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/register/passion"
                          element={
                            <ProtectedRoute>
                              <Passion />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/register/uploadPicture"
                          element={
                            <ProtectedRoute>
                              <UploadPicture />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/register/waiting"
                          element={
                              <WaitingScreen />
                          }
                        />

                        {/* Default route, also protected */}
                        <Route
                          path="*"
                          element={
                            <ProtectedRoute>
                              <Dashboard />
                            </ProtectedRoute>
                          }
                        />
                      <Route path="/post/:id" element={<PostLayout />} />
                      <Route path="/privacy_policy" element={<PrivacyPolicy/>} />
                      <Route path="/contact" element={<ContactUs/>} />
                      </Routes>
                    </ProfileState>
                  </NotificationState>
                </MatchState>
              </SearchState>
            </ReelState>
          </PostState>
        </IsAuthStates>
      </RegisterStates>
    </Router>
  );
}

export default App;
